export const BU = 5

export const BARCODE_TYPE_PRODUCT = 'product'
export const BARCODE_TYPE_POSITION = 'position'
export const BARCODE_TYPE_UNKNOWN = 'unknown'
